export const SET_QUESTIONS_INCREMENTAL = 'SET_QUESTIONS_INCREMENTAL';

export const SET_CATEGORIES = 'SET_CATEGORIES';
export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE';

export const SET_QUESTIONS = 'SET_QUESTIONS';
export const GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';

export const SEARCH_QUESTIONS_REQUEST = 'SEARCH_QUESTIONS_REQUEST';
export const SEARCH_QUESTIONS_SUCCESS = 'SEARCH_QUESTIONS_SUCCESS';
export const SEARCH_QUESTIONS_FAILURE = 'SEARCH_QUESTIONS_FAILURE';

export const GET_QUESTIONS_BY_TAG_REQUEST = 'GET_QUESTIONS_BY_TAG_REQUEST';
export const GET_QUESTIONS_BY_TAG_SUCCESS = 'GET_QUESTIONS_BY_TAG_SUCCESS';
export const GET_QUESTIONS_BY_TAG_FAILURE = 'GET_QUESTIONS_BY_TAG_FAILURE';

export const SELECT_QUESTION = 'SELECT_QUESTION';

export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const RESET_TAB_STATE = 'RESET_TAB_STATE';
export const RESET_QUESTION_BANK_STATE = 'RESET_QUESTION_BANK_STATE';

export const SET_QUESTION_FAVORITE = 'SET_QUESTION_FAVORITE';
